import { useCallback, useEffect, useState } from "react";
import ReactModal from "react-modal";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "flowbite-react";
import { useModal } from "context/ModalContext";
import { useAppStore } from "store";
import { Gift } from "@phosphor-icons/react";

export function PurchaseModal(props: any) {
  ReactModal.setAppElement("#modal");

  const modalID = "purchase";

  const { user } = useAppStore();

  const [modalIsOpen, setIsOpen] = useState(false);
  const { openModal, closeModal, showModal, modalData } = useModal();

  const [loading, setLoading] = useState(false);
  const [selectedCortesia, setSelectedCortesia] = useState<any>(null);

  async function handleCloseModal() {
    closeModal();
  }

  function afterOpenModal() {}

  const handleShowTerms = useCallback(() => {
    showModal("purchase-terms", modalData);
  }, [showModal, modalData]);

  useEffect(() => {
    if (openModal === modalID) {
      setIsOpen(true);
      // Define a cortesia selecionada a partir do modalData
      setSelectedCortesia(modalData);
    } else {
      setIsOpen(false);
      setSelectedCortesia(null);
    }
  }, [openModal, modalData]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Badge Modal"
        portalClassName="relative z-40"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="bg-white rounded-xl p-3 px-10 max-w-[450px] flex flex-col items-center flex-none mx-5 gap-3">
              <h1 className="text-xl lg:text-3xl mt-4 font-bold text-blue-500 text-center">
                Premio redimido
              </h1>
              {loading ? (
                <div className="text-center p-3 font-bold">
                  <p>CARGANDO...</p>
                </div>
              ) : null}

              {!loading && selectedCortesia ? (
                <div className="relative my-3 flex flex-col items-center">
                  <QRCodeSVG
                    value={selectedCortesia._id}
                    width={200}
                    height={200}
                    style={selectedCortesia.redeem?.status === "USED" ? { filter: "grayscale(100%)" } : {}}
                  />
                  <p className="text-center mt-2">
                    Muestre este código QR
                    <br />
                    al administrador del premio
                  </p>
                  {selectedCortesia.redeem?.status === "USED" ? (
                    <p className="text-center text-red-500 font-bold mt-1">USADO</p>
                  ) : (
                    <p className="text-center text-green-500 font-bold mt-1">DISPONIBLE</p>
                  )}
                </div>
              ) : null}

              {!loading && !selectedCortesia ? (
                <div className="relative p-3 font-bold text-xl text-center border rounded-xl border-brand-red">
                  <Gift size={48} className="text-brand-red mx-auto" />
                  <p className="leading-tight">
                    Este premio ya ha sido utilizado o ha caducado.
                  </p>
                </div>
              ) : null}

              <div className="py-3 relative z-10 flex gap-3">
                <Button
                  fullSized
                  type="button"
                  onClick={() => handleCloseModal()}
                  className="bg-brand-red"
                >
                  CERRAR
                </Button>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
}
